import type { CSSProperties } from 'react';

import type { SectionHeight } from '@commons/types/styles';

/**
 * Type definition for the available section heights from Drupal.
 */

export type SectionMinHeightType = SectionHeight | 'none' | 'custom';

/**
 * Helper function to get a section's min height based on the provided type.
 *
 * @param type - The type of the min height.
 * @param customValue - A custom min height value.
 *
 * @returns The min height value.
 */

export const getSectionMinHeight = (
  type: SectionMinHeightType,
  customValue?: CSSProperties['minHeight']
) => {
  let minHeight: CSSProperties['minHeight'] | undefined;

  switch (type) {
    case 'none':
      break;
    case 'custom':
      minHeight = customValue;
      break;
    default:
      minHeight = `var(--section-${type}-height)`;
      break;
  }

  return minHeight;
};
